var map = {
	"./av3crv.svg": 238,
	"./avax.svg": 239,
	"./bal.svg": 240,
	"./bnb.svg": 94,
	"./busd.svg": 95,
	"./crv.svg": 241,
	"./curve.svg": 242,
	"./curve_dai_usdc_usdt.svg": 139,
	"./curve_steth.svg": 243,
	"./dai.svg": 244,
	"./dqlink.svg": 245,
	"./eth.svg": 96,
	"./ftm.svg": 246,
	"./hyve.svg": 247,
	"./qiavax.svg": 248,
	"./qibtc.svg": 249,
	"./qidai.svg": 250,
	"./qieth.svg": 251,
	"./qiusdc.svg": 252,
	"./qiusdt.svg": 253,
	"./radar.png": 254,
	"./radar.svg": 54,
	"./renbtc.svg": 255,
	"./savax.png": 256,
	"./sradar.svg": 257,
	"./steth.svg": 258,
	"./usdc.svg": 259,
	"./usdr.svg": 59,
	"./usdt.svg": 260,
	"./ust.svg": 261,
	"./wbtc.svg": 262,
	"./weth.svg": 263,
	"./yearn.svg": 264,
	"./yearn_weth.svg": 265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;